import { useInfiniteQuery } from '@tanstack/react-query'
import { activityFeedItemSchema, pageSchema } from '@witty-board/shared'
import { apiRequest } from './client.js'
import { buildQueryString } from '../lib/query-string.js'

/** Prefijo de todas las consultas del histórico global; `query-client.ts` lo invalida tras cualquier escritura. */
export const activityFeedQueryKey = ['activity'] as const

const FEED_PAGE_SIZE = 20

/**
 * Actividad reciente del Inicio (CLAUDE.md §6, fase 7): solo lo destacado
 * (`highlights`), desde `since`, en tandas de 20 con "ver más".
 */
export function useRecentActivityQuery(since: string) {
  return useInfiniteQuery({
    queryKey: [...activityFeedQueryKey, 'recent', since] as const,
    queryFn: ({ pageParam }) =>
      apiRequest(
        `/activity${buildQueryString({
          highlights: true,
          since,
          limit: FEED_PAGE_SIZE,
          cursor: pageParam === '' ? undefined : pageParam,
        })}`,
        pageSchema(activityFeedItemSchema),
      ),
    // Cadena vacía = primera página: `undefined` no serviría para inferir el tipo del cursor.
    initialPageParam: '',
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
  })
}
